/**
 *	This code was gladly borrowed from
 *  https://github.com/getsentry/sentry-javascript/blob/a6f8dc26a4c7ae2146ae64995a2018c8578896a6/packages/utils/src/stacktrace.ts
 * 	and
 * 	https://github.com/getsentry/sentry-javascript/blob/d136f4e0bca43cda21db42da4e84bbe3448a70a1/packages/utils/src/instrument.ts
 */ import { getInstrumentTypeConfig } from '../../config';
const defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ const getFunctionName = (fn)=>{
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    } catch (_e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
};
export const triggerHandlers = (type, data)=>{
    const { handlers, transformer } = getInstrumentTypeConfig(type);
    if (!type || !handlers) {
        return;
    }
    for (const handler of handlers || []){
        try {
            const transformedData = transformer ? transformer(data) : data;
            transformedData && handler(transformedData);
        } catch (e) {
            console.warn(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${getFunctionName(handler)}\nError: ${e}`);
        }
    }
};
